import React, { useEffect } from 'react';
import { AppBar, Toolbar, Button, Box } from '@mui/material';
import { ExitToApp, Home } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { startLogout } from '../../../actions/auth';
import {
  blue_pilu,
  LOGO_PILU_WHITE_LINK,
  whichEnvURL,
  whichPath,
  white_pilu,
} from '../../../helpers/utils';

{/** Button component for the header */}
const HeaderButton = ({ onClick, variant, color, startIcon, text, style }) => (
  <Button
    onClick={onClick}
    variant={variant}
    color={color}
    style={style}
    sx={{ fontWeight: 'bold', marginRight: '10px' }}
    startIcon={startIcon}
  >
    {text}
  </Button>
);

{/** Logo component */}
const Logo = ({ src, alt, size, margin }) => (
  <img
    style={{
      margin: margin,
      width: `${size}%`,
      height: `${size}%`,
    }}
    src={src}
    alt={alt}
  />
);

{/** Header component */}
const Header = ({ children, backgroundColor, padding }) => (
  <AppBar
    position="fixed"
    sx={{
      background: backgroundColor,
      padding: padding,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    {children}
  </AppBar>
);

{/** Main header component for tracking */}
export const HeaderTracking = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  {/** Handler for logout */}
  const handleLogout = () => {
    const path = '/tracking';
    localStorage.setItem('lastPathPilu', path);
    dispatch(startLogout());
    navigate(path);
  };

  {/** Effect to set the last path on pathname change */}
  useEffect(() => {
    const path = pathname;
    localStorage.setItem('lastPathPilu', path);
  }, [pathname]);

  const logoPiluSrc = whichEnvURL(true) === 'live'
    ? `${whichPath()}/static/img/logo/logo-no-bg-light.png`
    : LOGO_PILU_WHITE_LINK;

  const logoSaroSrc = whichEnvURL(true) === 'live'
    ? `${whichPath()}/static/img/logo/logo-saro-removebg.png`
    : 'https://sarouniformes.com.mx/assets/img/logo.png';

  return (
    <Header backgroundColor={blue_pilu} padding="10px">
      <Toolbar
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '96%',
          maxWidth: '96%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            width: '55%',
          }}
        >
          <Logo src={logoPiluSrc} alt="Pilu Logo" size={9} margin="0 25px 0 0" />
          <Logo src={logoSaroSrc} alt="Saro Logo" size={12} margin="0 0 0 20px" />
        </Box>

        <Box
          sx={{
            width: '45%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
          }}
        >
          {pathname === '/tracking/mis-pedidos' || pathname === '/tracking/pedidos-tabla' ? (
            <>
              <HeaderButton
                onClick={() => {
                  const path = '/tracking/mis-pedidos';
                  localStorage.setItem('lastPathPilu', path);
                  navigate(path);
                }}
                variant="contained"
                style={{ backgroundColor: white_pilu, color: blue_pilu }}
                startIcon={<Home />}
                text="Inicio"
              />
              <HeaderButton
                onClick={handleLogout}
                variant="contained"
                color="error"
                startIcon={<ExitToApp />}
                text="Cerrar sesión"
              />
            </>
          ) : (
            <>
              {/** Future buttons for registration and login
              <HeaderButton
                onClick={() => {
                  const path = '/tracking/';
                  localStorage.setItem('lastPathPilu', path);
                  navigate(path);
                }}
                variant="contained"
                color="success"
                startIcon={<PersonAdd />}
                text="Registro"
              />
              <HeaderButton
                onClick={() => {
                  const path = '/tracking/inicio-de-sesion';
                  localStorage.setItem('lastPathPilu', path);
                  navigate(path);
                }}
                variant="contained"
                color="primary"
                startIcon={<AccountCircle />}
                text="Inicio de sesión"
              /> */}
            </>
          )}
        </Box>
      </Toolbar>
    </Header>
  );
};
